<template>
  <v-content>
    <v-container fluid class="ma-0 pa-3">
      <v-layout>
        <v-flex xs12>
          <Service-list
            :cargando="Cargando"
            :servicios="servicios"
            @recargar="buscar"
            @manifiesto="manifiesto"
            @exportar="_exportarServicios"
            @importar="_importarServicios"
            @exportarPods="_exportarPods"
            :filtro="Filtro"
          ></Service-list>
        </v-flex>
      </v-layout>
    </v-container>
    <v-tooltip left>
      <v-btn
        fab
        fixed
        bottom
        right
        dark
        slot="activator"
        color="primary"
        @click="crear"
      >
        <v-icon dark class="pt-3">add</v-icon>
      </v-btn>
      <span>{{ $t("servicios.nuevoServicio") }}</span>
    </v-tooltip>
  </v-content>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ServiceList from "@/components/services/ServiceListV2";
import ServiceFilter from "@/components/services/ServiceFilter";

export default {
  components: {
    ServiceList,
    ServiceFilter
  },
  name: "Servicio",
  data() {
    return {
      Filtro: {
        FechaInicio: this.obtenerFechaInicio(), //this.obtenerFechaTest(),//
        FechaFin: this.obtenerFechaFin(), //this.obtenerFechaTest()//
        Estados: [],
        Poblacion: "",
        Referencia: "",
        Numero: ""
      },
      Cargando: false,
      Firefox: typeof InstallTrigger !== "undefined" || window.StyleMedia
    };
  },
  beforeMount() {
    this.cargar();
    console.log(this.filtroVuex);
    this.Filtro = this.filtroVuex;
  },
  methods: {
    crear() {
      this.$router.push("/servicios/create");
    },
    obtenerFechaInicio() {
      const toTwoDigits = num => (num < 10 ? "0" + num : num);
      var date = new Date();
      date.setDate(date.getDate() - 2); // -3 días
      let year = date.getFullYear();
      let month = toTwoDigits(date.getMonth() + 1);
      let day = toTwoDigits(date.getDate());
      return `${year}-${month}-${day}`;
    },
    obtenerFechaFin() {
      let date = new Date();
      date.setDate(date.getDate() + 4); // +4 días
      const toTwoDigits = num => (num < 10 ? "0" + num : num);
      let year = date.getFullYear();
      let month = toTwoDigits(date.getMonth() + 1);
      let day = toTwoDigits(date.getDate());
      return `${year}-${month}-${day}`;
    },
    async buscar() {
      this.Cargando = true;
      await this.fetchServicios(this.Filtro);
      this.Cargando = false;
    },
    async cargar() {
      if (!this.necesitaRecargar) return;
      this.Cargando = true;
      await this.fetchServicios(this.Filtro);
      this.Cargando = false;
    },
    async manifiesto() {
      this.$store.commit("setLoading", true, { root: true });
      await this.generarManifiesto(this.Filtro);
      this.$store.commit("setLoading", false, { root: true });
    },
    async _exportarServicios() {
      this.$store.commit("setLoading", true, { root: true });
      await this.exportarServicios(this.Filtro);
      this.$store.commit("setLoading", false, { root: true });
    },
    async _exportarPods() {
      this.$store.commit("setLoading", true, { root: true });
      await this.exportarPods(this.Filtro);
      this.$store.commit("setLoading", false, { root: true });
    },
    async _importarServicios() {
      this.$store.commit("setLoading", true, { root: true });
      await this.exportarServicios(this.Filtro);
      this.$store.commit("setLoading", false, { root: true });
    },
    obtenerFechaTest() {
      return "2019-03-07";
    },
    ...mapActions("services", [
      "fetchServicios",
      "generarManifiesto",
      "exportarServicios",
      "exportarPods"
    ])
  },
  computed: {
    ...mapGetters("services", ["servicios"]),
    ...mapGetters("services", ["filtroVuex"]),
    ...mapGetters("services", ["necesitaRecargar"])
  }
};
</script>
